export default "__VITE_ASSET__DmEOYygj__"